// action to load convenios and each respective plans
const loadCredits = () => {
  return {
    type: 'LOAD_CREDITS'
  }
}

const loadCreditsSuccess = (data, messages) => {
  return {
    type: 'LOAD_CREDITS_SUCCESS',
    data,
    messages
  }
}

const cleanCredits = (data, messages) => {
  return {
    type: 'CLEAN_CREDITS',
    data,
    messages
  }
}

const loadCreditsFailure = (error) => {
  return {
    type: 'LOAD_CREDITS_FAILURE',
    payload: error
        
  }
}

const requestCredits = () => {
  return {
    type: 'REQUEST_CREDITS'
  }
}

const requestCreditsSuccess = (response) => {
  return {
    type: 'REQUEST_CREDITS_SUCCESS',
    payload: response
  }
}

const requestCreditsFailure = (error) => {
  return {
    type: 'REQUEST_CREDITS_FAILURE',
    payload: error
  }
}
  
export {
  loadCredits,
  loadCreditsSuccess,
  loadCreditsFailure,
  requestCredits,
  requestCreditsSuccess,
  cleanCredits,
  requestCreditsFailure
}